/* ND CRO: one-tap "Subscribe & save" upgrade on a cart drawer line.
 *
 * Follows the same path free-gift-guard.js uses: POST /cart/change.js, then ask
 * the theme to re-render the drawer via its own event bus. No DOM surgery here -
 * the Liquid decides what the line should look like afterwards, and the upgrade
 * button removes itself because the line then has a selling plan.
 *
 * Listener is delegated on document because the drawer replaces the innerHTML of
 * its dynamic regions on every cart update, which would drop a bound handler.
 */
(function () {
  'use strict';

  if (window.__ndSubUpgradeBound) return;
  window.__ndSubUpgradeBound = true;

  var busy = false;

  document.addEventListener('click', function (event) {
    var target = event.target;
    var btn = target && target.closest ? target.closest('[data-nd-sub-upgrade]') : null;
    if (!btn) return;

    event.preventDefault();
    if (busy) return;

    var key = btn.getAttribute('data-line-key');
    var plan = parseInt(btn.getAttribute('data-plan'), 10);
    var qty = parseInt(btn.getAttribute('data-line-qty'), 10);
    if (!key || !plan) return;
    if (!qty || qty < 1) qty = 1;

    busy = true;
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, selling_plan: plan })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/change.js responded ' + res.status);
        return res.json();
      })
      .then(function () {
        /* On the cart PAGE there is no drawer to re-render. */
        if (window.location.pathname.indexOf('/cart') === 0) {
          window.location.reload();
          return;
        }
        if (window.eventBus && window.eventBus.emit) {
          window.eventBus.emit('render:cart:drawer');
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        /* Leave the line exactly as it was and let the customer retry. */
        console.error('[nd-sub-upgrade]', err);
        btn.classList.remove('is-busy');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
      })
      .then(function () { busy = false; });
  });
})();
